import { render } from "./videocard.vue?vue&type=template&id=cad4be62&scoped=true"
import script from "./videocard.vue?vue&type=script&lang=js"
export * from "./videocard.vue?vue&type=script&lang=js"

import "./videocard.vue?vue&type=style&index=0&id=cad4be62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad4be62"]])

export default __exports__